export class QualityControlPipe {
    id!: string
    job!: string
    typeOfPipe!: string
    processForPipe!: string
    minimumBedding!: string
    minimumBeddingWidth!: string
    minimumAbovePipe!: string
    beddingMaterial!: string
    beddingRequiredCompaction!: string
    trenchZoneBackfillMaterial!: string
    trenchZoneMaxLift!: string
    trenchZoneRequiredCompaction!: string
    trenchZoneOptimumMoisture!: string
    trenchZoneProduct!: string
    trenchZoneVendorId!: number | undefined
    locationToBeInstalled!: string
    vendor!: number | undefined
    createdOn!: Date
    modifiedOn!: Date
}
